import { z } from "zod";
import { GroupBaseSchema } from "../generated/Group";

export const putUserSchema = z.object({
  id: z.string().nullable(),
  login_id: z.string(),
  name: z.string(),
  authority: z.number(),
  password: z.string(),
  deleted_at: z.number().nullable(),
}).strip();

export const putGroupSchema = z.object({
  id: z.string().nullable(),
  name: z.string(),
  deleted_at: z.number().nullable(),
}).strip();

export const getUserSchema = z.object({
  id: z.string().uuid(),
  group_id: z.string().uuid(),
  name: z.string(),
  authority: z.number(),
  deleted_at: z.number().nullable(),
  Group: GroupBaseSchema.base
});
export type getUserType = z.infer<typeof getUserSchema>;

// ユーザー一覧(/get-users)用。オンライン専用のため login_id を含む(IDBのオフライン復元対象外)。
export const getUserListItemSchema = getUserSchema.extend({
  login_id: z.string(),
});
export const getUserRowsSchema = getUserListItemSchema.array();
export type getUserListItemType = z.infer<typeof getUserListItemSchema>;

// 利用者の正規化応答(重複排除)。行は Group をネストせず、related.Groups の id 結合で
// ネスト形(getUserType)へ復元する(復元は util/hydrators/userHydrator の共通ハイドレータ)。
// キー名は IndexedDB の SetCache 収集キー(PascalCase)に合わせてある。
// 単一取得(get-user-from-id)は login_id なし、一覧(get-users)は login_id ありという
// 従来応答の情報量差をそのまま踏襲する。
export const normalizedUserResponseSchema = z.object({
  Users: getUserSchema.omit({ Group: true }).strip().array(),
  related: z.object({
    Groups: GroupBaseSchema.base.array(),
  }),
});
export type NormalizedUserResponse = z.infer<typeof normalizedUserResponseSchema>;

export const normalizedUserRowsResponseSchema = z.object({
  Users: getUserListItemSchema.omit({ Group: true }).strip().array(),
  related: z.object({
    Groups: GroupBaseSchema.base.array(),
  }),
});
export type NormalizedUserRowsResponse = z.infer<typeof normalizedUserRowsResponseSchema>;

export const localUserSchema = z.object({
  id: z.string().uuid(), 
  group_id: z.string().uuid(), 
  name: z.string(),
  authority: z.number(),
  deleted_at: z.number().nullable(),
}).strip();
export type localUserType = z.infer<typeof localUserSchema>;
